import { useCallback } from 'react';
import { Box, Popover, Typography } from '@mui/material';
import { Form, FormRenderProps } from 'react-final-form';
import { bindPopover } from 'material-ui-popup-state';

import { Button, Select } from '@occc-app/design-system';
import { Retailer_Network_User_Role } from '@occc/graphql';

import {
  SiteAdminsAndUsersFilterFormValues,
  UserRoleFilterFormValues,
} from './user-role-filter.types';

const userRoleFilterSelectOptions = [
  { label: 'All', value: 'all' },
  { label: 'Site Admin', value: Retailer_Network_User_Role.SiteAdmin },
  { label: 'Site User', value: Retailer_Network_User_Role.SiteUser },
];

type UserRoleFilterProps = {
  userRoleFilter: UserRoleFilterFormValues;
  userFilterPopoverProps: ReturnType<typeof bindPopover>;
  setUserRoleFilter: (value: UserRoleFilterFormValues) => void;
};

export const UserRoleFilter = ({
  userRoleFilter,
  userFilterPopoverProps,
  setUserRoleFilter,
}: UserRoleFilterProps) => {
  const onUserRoleFilterSubmit = (values: SiteAdminsAndUsersFilterFormValues) => {
    setUserRoleFilter(values.userRoleFilter);
    userFilterPopoverProps.onClose();
  };

  const onUserRoleFilterReset = useCallback(() => {
    setUserRoleFilter(undefined);
    userFilterPopoverProps.onClose();
  }, [userFilterPopoverProps, setUserRoleFilter]);

  const renderForm: FormRenderProps<SiteAdminsAndUsersFilterFormValues>['render'] = useCallback(
    ({ handleSubmit, form }: FormRenderProps<SiteAdminsAndUsersFilterFormValues>) => {
      const reset = () => {
        form.reset();
        onUserRoleFilterReset();
      };

      return (
        <form onSubmit={handleSubmit}>
          <Box px={4} pt={4}>
            <Typography paragraph>User Role</Typography>
            <Select name='userRoleFilter' label='User Role' data={userRoleFilterSelectOptions} />
          </Box>
          <Box display='flex' justifyContent='flex-end' px={3} py={2}>
            <Button size='small' color='error' onClick={reset}>
              Reset
            </Button>
            <Button type='submit' size='small' color='primary'>
              Apply
            </Button>
          </Box>
        </form>
      );
    },
    [onUserRoleFilterReset],
  );

  return (
    <Popover
      {...userFilterPopoverProps}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      keepMounted
      PaperProps={{
        sx: {
          maxWidth: '460px',
          minWidth: '300px',
        },
      }}
    >
      <Form<SiteAdminsAndUsersFilterFormValues>
        render={renderForm}
        onSubmit={onUserRoleFilterSubmit}
        initialValues={{ userRoleFilter }}
      />
    </Popover>
  );
};
